module.exports = __webpack_public_path__ + "static/header-rx-1ed7de2c469f3b79c53d23b43ec1f6f2.jpg";